import { MathUtils, Vector3 } from "three";
import type { LevelDefinition, Vec3Tuple } from "../levels/types";

const defaultLookAt = new Vector3(0, 2.5, 0);

function addPoint(points: Vector3[], tuple: Vec3Tuple) {
  points.push(new Vector3(tuple[0], tuple[1], tuple[2]));
}

function getLevelPoints(level: LevelDefinition) {
  const points: Vector3[] = [];

  level.spawnPoints.singleplayer.forEach((spawn) => addPoint(points, spawn.position));
  level.spawnPoints.multiplayer.forEach((spawn) => addPoint(points, spawn.position));
  level.markers.forEach((marker) => addPoint(points, marker.position));
  level.triggerVolumes.forEach((volume) => addPoint(points, volume.center));
  level.navGraph.nodes.forEach((node) => addPoint(points, node.position));

  if (!points.length) {
    points.push(defaultLookAt.clone());
  }

  return points;
}

function getOrbitCenter(level: LevelDefinition) {
  const points = getLevelPoints(level);
  const center = new Vector3();

  points.forEach((point) => center.add(point));
  center.multiplyScalar(1 / points.length);

  return { center, points };
}

export function sampleBackgroundCamera(level: LevelDefinition, time: number) {
  const { center, points } = getOrbitCenter(level);
  let maxHorizontalDistance = 18;

  points.forEach((point) => {
    const dx = point.x - center.x;
    const dz = point.z - center.z;
    maxHorizontalDistance = Math.max(maxHorizontalDistance, Math.hypot(dx, dz));
  });

  const radius = MathUtils.clamp(maxHorizontalDistance * 1.22, 22, 28);
  const angle = time * 0.12 + Math.PI * 0.18;
  const verticalBob = Math.sin(time * 0.45) * 0.8;
  const drift = Math.sin(time * 0.18) * 1.5;
  const lookAt = center.clone().add(new Vector3(Math.cos(time * 0.2) * 1.8, 2.5 + Math.sin(time * 0.28) * 0.5, Math.sin(time * 0.2) * 1.8));
  const position = new Vector3(
    center.x + Math.cos(angle) * (radius + drift),
    MathUtils.clamp(center.y + 10 + verticalBob, 8, 14),
    center.z + Math.sin(angle) * radius
  );

  return { position, lookAt };
}
